import React from 'react';
import { useLocale } from '../../contexts/LocaleContext';
import { TRANSLATION_CONSTANTS } from '../../app-consts/translations';
import { Button, Type } from 'mesh-component-library';
import { TIRE_CHANGE } from '../../app-consts/appConstants';

export const TowNotNeeded = ({ navigateScheduleService }) => {
  const getTranslatedText = useLocale();
  const serviceText = localStorage.getItem("serviceText");

  return (
        <div role="main" className="l-container-TowNotNeeded static">
          <div className='l-container-TowNotNeeded__button_content d-flex flex-column'>
            <Type
              variant="brand"
              align="left"
              size="3xl"
              weight="semibold"
              lineHeight="md"
              data-testid="towNotNeeded-title"
              className="l-container-TowNotNeeded__hd u-vr-3 u-hr-2"
            >
              {getTranslatedText(TRANSLATION_CONSTANTS.WE_WONT_NEED_TO_TOW)}
            </Type>
            <Type
              variant="brand"
              align="left"
              lineHeight="md"
              data-testid="towNotNeeded-text"
              className="l-container-TowNotNeeded__text u-vr-3 u-hr-2"
            >
              {serviceText === TIRE_CHANGE 
                    ? getTranslatedText(TRANSLATION_CONSTANTS.WE_CAN_SEND_SOMEONE_TO_HELP) 
                    : getTranslatedText(TRANSLATION_CONSTANTS.WE_CAN_SEND_SERVICE_PROVIDER)}
            </Type>
          </div>
          <div className='l-container-TowNotNeeded__button_footer d-flex flex-column'>
            <Button
              size="lg"
              hasUpgrade
              id="TowNotNeeded-ContinueButton"
              utils={{ fullWidth: true }}
              onClick={navigateScheduleService}
              aria-label="Triage Steps Continue Button"
            >
              {serviceText === TIRE_CHANGE 
                    ? getTranslatedText(TRANSLATION_CONSTANTS.CONTINUE_TIRE_CHANGE)
                    : getTranslatedText(TRANSLATION_CONSTANTS.CONTINUE_LOCKOUT)}
            </Button>
          </div>
        </div>
  );
};
